import { render, staticRenderFns } from "./loanmonthlyreport.vue?vue&type=template&id=2c3b033e"
import script from "./loanmonthlyreport.vue?vue&type=script&lang=js"
export * from "./loanmonthlyreport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports